import React from 'react';
import { formatDate, formatDateTime } from '../../../utils/DateHelper';

const DateFormatter = props => {
  let divStyle = { textAlign: 'left' };

  let value = props.value ? props.value : '';
  let expandedValue;
  let format = props.dependentValues.options && props.dependentValues.options.format;

  if (props.includeTime || (props.dependentValues.options && props.dependentValues.options.includeTime)) {
    expandedValue = formatDateTime(value);
  }

  value = formatDate(new Date(value), format);

  return (
    <div className="" title={expandedValue || value} style={divStyle}>
      {value}
    </div>
  );
};

export default DateFormatter;
